<template>
  <v-dialog v-model="isDialogActive" fullscreen>
    <v-toolbar dark color="primary">
      <v-spacer />
      <span class="headline">Gallery</span>
      <v-spacer />
      <v-btn
        icon
        dark
        @click="closeDialog"
        :class="{ 'ml-n8': $vuetify.breakpoint.smAndDown }"
      >
        <v-icon>$vuetify.icons.close</v-icon>
      </v-btn>
    </v-toolbar>
    <GalleryCategories ref="galleryCategories" />
  </v-dialog>
</template>

<script>
export default {
  name: "GalleryDialog",
  components: {
    GalleryCategories: () => import("@/components/gallery/GalleryCategories"),
  },
  data() {
    return {
      isDialogActive: false,
    };
  },
  methods: {
    closeDialog() {
      this.pictures = [];
      this.isDialogActive = false;
    },
    showDialog(category) {
      this.isDialogActive = true;
      this.$refs.galleryCategories.loadPictures(category);
    },
  },
};
</script>
